import { ENUM_FORM_DISPLAY } from "../../components/pageList";

const initialValues = {};

export const StatementAddForm = {
  name: "addSchema",
  title: "New Statement",
  description: "Please follow the step to create a New Statement",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "1000px", //xs, sm, xl  ....100%
  },

  apiEntity: "Statements",
  initialValues,

  layout: {
    containers: [],
    fields: [],
  },
};

export const StatementEditForm = {};
